
import Vue from "vue";
import {SendcloudService, IShippingMethod} from "@/services/sendcloud-service";
import { Sale } from "@/models/base";
import {Parcel} from "@/utils/sendcloud/parcel";
import AppCountryCodeAutocomplete from "@/components/CountryCodeAutocomplete.vue";
import { printPdf } from "@/utils/pdf";
import { HttpError } from "@/utils/services/http-error";

export default Vue.extend({
	data(){
		return {
			shippingMethods: [] as IShippingMethod[],
			parcel: new Parcel(),
			isCreatingLabel: false,
			shippingMethodSearchInput: ""
		};
	},
	props: {
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		filteredShippingMethods():string[]{
			let parts = this.shippingMethodSearchInput.toLowerCase().split(" ");
			return this.shippingMethods.filter(f=>{
				for (let part of parts) {
					if (f.name.toLowerCase().indexOf(part) == -1) {
						return false;
					}
				}
				return true;
			}).map(s=>{
				return s.name;
			});
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async createLabel(){
			if (this.isCreatingLabel) return;
			this.isCreatingLabel = true;
			try{
				let parcel = await SendcloudService.createShipment(this.sale.ID, this.parcel);
				let hasLabel = false;
				if (parcel.label) {
					let labelUrl = parcel.label.normal_printer[0];
					if (!labelUrl) {
						labelUrl = parcel.label.label_printer;
					}
					if (labelUrl) {
						let label = await SendcloudService.downloadLabel(labelUrl);
						printPdf(label, "label.pdf");
						hasLabel = true;
					}
				}
				if (!hasLabel) {
					let message = this.$ct("no-label-received-from-sendcloud");
					let confirm = await this.$confirmBuilder().setMessage(message).setClass("info").setTitle(this.$ct("common.info")).show();
					if (confirm) {
						parcel.openInSendcloud();
					}
				}
				this.$emit("close");
			}catch(err){
				let e = err as HttpError;
				if (e.key == "SENDCLOUD_API_ERROR"){
					e.dontShow = true;
					let body = JSON.parse(e.data[0]);
					this.$wf.notify(body.error.message, "danger", 3000, "exclamation-triangle");
				}
			}
			this.isCreatingLabel = false;
		},
		getShippingMethodByName(name:string):IShippingMethod | undefined{
			return this.shippingMethods.find(f=>f.name == name);
		},
		onShippingMethodBlur(){
			if (this.filteredShippingMethods.length == 1) {
				let foundMethod = this.getShippingMethodByName(this.filteredShippingMethods[0]);
				if (foundMethod) {
					this.parcel.shipment = foundMethod;
				}
			}
			this.shippingMethodSearchInput = this.parcel.shipment.name;
		},
		onItemClicked(item:string){
			let foundMethod = this.getShippingMethodByName(item);
			if (!foundMethod) return;
			this.parcel.shipment = foundMethod;
			this.shippingMethodSearchInput = this.parcel.shipment.name;
		}
	},
	async created(){
		this.shippingMethods = await SendcloudService.getShippingMethods();
		this.parcel.setDataFromSale(this.sale);
		this.parcel.shipment = this.shippingMethods[0];
		this.shippingMethodSearchInput = this.parcel.shipment.name;
	},
	components: {
		AppCountryCodeAutocomplete
	},
	i18nEx: {
		componentPrefix: "components.sendcloud"
	}
});
